import { render, staticRenderFns } from "./cargosConferenceEvents.vue?vue&type=template&id=86d1ebf4&scoped=true&"
import script from "./cargosConferenceEvents.vue?vue&type=script&lang=js&"
export * from "./cargosConferenceEvents.vue?vue&type=script&lang=js&"
import style0 from "./cargosConferenceEvents.vue?vue&type=style&index=0&id=86d1ebf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d1ebf4",
  null
  
)

export default component.exports